import { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { api, errorMessage } from "@/lib/api";

export const NoteCell = ({ row, name, onSave }) => {
  const [val, setVal] = useState(row.note || "");
  const save = () => { if (val.trim() !== (row.note || "")) onSave(row, val.trim()); };
  return (
    <input value={val} onChange={(e) => setVal(e.target.value)} onBlur={save} onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
      maxLength={500} placeholder="Add note…" className="tn-input h-8 text-xs min-w-[180px]" data-testid={`admin-${name}-note-${row.id}`} />
  );
};

export const InviteBar = ({ selected, rows, headers, onDone }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const already = rows.filter((r) => selected.includes(r.id) && r.invited_at).length;

  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/waitlist/invite", { ids: selected }, { headers });
      toast.success(`Beta invite sent to ${data.invited} ${data.invited === 1 ? "person" : "people"}`);
      onDone(data.invited_at);
    } catch (e) { toast.error(errorMessage(e)); }
    setBusy(false);
    setOpen(false);
  };

  return (
    <>
      <button className="tn-btn h-9" disabled={!selected.length} onClick={() => setOpen(true)} data-testid="admin-invite-btn">
        <Send size={15} /> Send beta invite ({selected.length})
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="bg-[var(--tn-card)] border-[var(--tn-line)] text-[var(--tn-text)]" data-testid="admin-invite-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Send beta invite to {selected.length} {selected.length === 1 ? "person" : "people"}?</AlertDialogTitle>
            <AlertDialogDescription className="text-[var(--tn-muted)]">
              They'll get an email saying their early-access invite is ready and the team will be in touch with access details.
              {already > 0 && ` ${already} of them were already invited and will get it again.`}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="bg-transparent border-[var(--tn-line)]" data-testid="admin-invite-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); send(); }} disabled={busy} className="bg-[var(--tn-cyan)] text-black hover:bg-cyan-300" data-testid="admin-invite-confirm">
              {busy && <Loader2 size={15} className="animate-spin mr-1" />} Send invites
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
